import { ProfilingRequestSource } from 'clickNgo/configs/profiling/common'
import {
  OnboardingContactServiceMethods,
  OnboardingFail,
  OnboardingResponse,
  OnboardingServices,
} from 'clickNgo/configs/service/onboarding'
import { WebSocketStoreKeys } from 'clickNgo/configs/service/ws'
import { getAccessToken } from 'cng-common/helpers/access'
import WebSocketStore from 'core/classes/services/WebSocketStore'

import { ContactWorkflowStatus, IContact } from '../model/types'

import { omitUnchangedEmailPixels } from './mapping/omitUnchangedEmailPixels'

type UpdateContactResponse = {
  contactId: string
  email: string
  entryId375: number
  entryId379: number
  modifiedValues: string
  partnerId: string
  workflowStatus: ContactWorkflowStatus
  error: { message: string; field?: string }[]
}

type UpdateContactOptions = {
  forceRoles?: boolean
}

export const updateContact = async (
  { workflowStatus: contactWorkflowStatus, source: contactSource, ...contact }: Partial<IContact>,
  options?: UpdateContactOptions
) => {
  const token = getAccessToken()
  const wsClient = WebSocketStore.get(WebSocketStoreKeys.Onboarding)
  const workflowStatus = contactWorkflowStatus || ContactWorkflowStatus.New
  const source = contactSource || ProfilingRequestSource.ClickAndGoPortal
  const onboardingRequestId = contact.onboardingRequestId

  return wsClient.call({
    service: OnboardingServices.Contact,
    action: OnboardingContactServiceMethods.Update,
    payload: {
      workflowStatus,
      source,
      ...omitUnchangedEmailPixels(contact),
      ...(onboardingRequestId == null ? {} : { OnboardingRequestId: onboardingRequestId }),
      ...options,
    },
    token: token || undefined,
    withoutTokenRefresh: true,
    isAuth: true,
    returnError: true,
  }) as Promise<OnboardingResponse<OnboardingFail, UpdateContactResponse>>
}
